var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFromScratch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 67,
    viewBox: "0 0 97 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    x: 0,
    y: 0,
    width: 97,
    height: 67,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 97,
    height: 67,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    mask: "url(#b)",
    xlinkHref: "#a",
    stroke: "#6A6666",
    strokeWidth: 5,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromScratch);
export default __webpack_public_path__ + "static/media/from-scratch.545e7af8d75cb0933f09f089ba39cd1e.svg";
export { ForwardRef as ReactComponent };